import { DotsInputError } from "dots-ui/dotsInput";
import { ArrayHelpers, FieldArray } from "formik";
import { useAtom } from "jotai";
import _ from "lodash";
import { useContext } from "react";
import { ErrorUtils } from "../../../../utils";
import { AvisContext } from "../../context";
import { atomIsModalOpen, atomModalEditItemIndex, atomRowKeys } from "./atoms";
import { AvisEditableListModal } from "./components";
import { IAvisEditableListProps, IEditableListRowState } from "./types";
import { AvisEditableListComponentView } from "./";

export function AvisEditableListComponent<
  T extends object,
  P extends IEditableListRowState,
>(props: Readonly<IAvisEditableListProps<T, P>>): JSX.Element {
  const { res } = useContext(AvisContext);
  const { bag, bagField, initValue } = props;

  const [modalEditItemIndex] = useAtom(atomModalEditItemIndex);
  const [, setRowKeys] = useAtom(atomRowKeys);
  const [, setIsModalOpen] = useAtom(atomIsModalOpen);

  const handleModalConfirm = (values: P, arrayHelpers: ArrayHelpers) => {
    if (modalEditItemIndex != undefined) {
      //Edit value
      arrayHelpers.replace(modalEditItemIndex, values);
    } else {
      //Add new value
      //Default list add row behaviour
      const newKey = _.uniqueId();
      setRowKeys((oldArray) => (oldArray ? [...oldArray, newKey] : [newKey]));
      arrayHelpers.push({ ...values, rowState: "Add" });
    }

    setIsModalOpen(false);
  };

  return (
    <div className="avis-editable-list-wrapper">
      <FieldArray name={bagField.toString()}>
        {(arrayHelpers) => {
          return (
            <div className="avis-editable-list-inner">
              <AvisEditableListComponentView
                {...props}
                arrayHelpers={arrayHelpers}
              />
              <AvisEditableListModal<P>
                {...props}
                initData={
                  modalEditItemIndex != undefined
                    ? (bag.values[bagField] as Array<P>)[modalEditItemIndex]
                    : initValue
                }
                editMode={modalEditItemIndex != undefined}
                onConfirm={(values) => handleModalConfirm(values, arrayHelpers)}
              />
            </div>
          );
        }}
      </FieldArray>
      <DotsInputError
        error={ErrorUtils.getBagErrorText<T>(bag, bagField, res)}
      />
    </div>
  );
}
